module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-sp-page",
    style: ({
      'top': _vm.top
    })
  }, [_c('div', {
    staticClass: "sl-bg"
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticClass: "sl-cnt"
  }, [_c('p', [_vm._v(_vm._s(_vm.data.cnt1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.cnt2))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-btn"
  }, [(_vm.data.showBtn1) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.data.btn1))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.data.btn2))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c425322c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/sl-sp-page.vue
// module id = 1126
// module chunks = 1